if (!customElements.get('path-product-mobile-gallery')) {
  customElements.define(
    'path-product-mobile-gallery',
    class PathProductMobileGallery extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.mediaItems = Array.from(this.querySelectorAll('[data-path-media-id]'));
        this.thumbnailButtons = Array.from(this.querySelectorAll('[data-path-thumbnail]'));
        this.thumbnailStrip = this.querySelector('.path-product-mobile-gallery__thumbnails');
        this.status = this.querySelector('[data-path-gallery-status]');
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', this.onClick.bind(this), {
          signal: this.abortController.signal,
        });

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );

        const activeThumbnail = this.thumbnailButtons.find(
          (button) => button.getAttribute('aria-current') === 'true'
        );
        if (activeThumbnail && this.mobileMediaQuery.matches) {
          window.requestAnimationFrame(() => this.centerThumbnail(activeThumbnail));
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.variantChangeUnsubscriber?.();
      }

      onClick(event) {
        const thumbnail = event.target.closest('[data-path-thumbnail]');
        if (!thumbnail || !this.contains(thumbnail)) return;

        this.setActiveMedia(thumbnail.dataset.mediaId, {
          announce: true,
          scrollThumbnail: true,
        });
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.dataset.sectionId) return;

        const mediaId = event.data.variant?.featured_media?.id;
        if (!mediaId) return;

        this.setActiveMedia(mediaId, {
          announce: this.mobileMediaQuery.matches,
          scrollThumbnail: this.mobileMediaQuery.matches,
        });
      }

      setActiveMedia(mediaId, { announce = false, scrollThumbnail = false } = {}) {
        const normalizedMediaId = String(mediaId);
        const activeMedia = this.mediaItems.find((item) => item.dataset.pathMediaId === normalizedMediaId);
        const activeThumbnail = this.thumbnailButtons.find(
          (button) => button.dataset.mediaId === normalizedMediaId
        );

        if (!activeMedia || !activeThumbnail) return;

        this.mediaItems.forEach((item) => {
          const isActive = item === activeMedia;
          item.hidden = !isActive;
          item.classList.toggle('is-active', isActive);
        });

        this.thumbnailButtons.forEach((button) => {
          const isActive = button === activeThumbnail;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (scrollThumbnail) this.centerThumbnail(activeThumbnail);
        if (announce && this.status) this.status.textContent = activeThumbnail.getAttribute('aria-label');
      }

      centerThumbnail(thumbnail) {
        if (!this.thumbnailStrip) return;

        const targetLeft = thumbnail.offsetLeft - (this.thumbnailStrip.clientWidth - thumbnail.offsetWidth) / 2;
        this.thumbnailStrip.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: this.reducedMotionMediaQuery.matches ? 'auto' : 'smooth',
        });
      }
    }
  );
}
